if (!customElements.get('collapsible-group')) {
  class CollapsibleGroup extends HTMLElement {
    constructor() {
      super();
      this.closeOtherDetails = this.closeOtherDetails.bind(this);
      this.handleDetailClick = this.handleDetailClick.bind(this);
    }

    connectedCallback() {
      this.setupDetails();
    }

    disconnectedCallback() {
      this.removeEventListeners();
    }

    setupDetails() {
      this.details = this.querySelectorAll('details');

      this.details.forEach((detail) => {
        const summary = detail.querySelector('summary');
        const content = detail.querySelector('.accordion__container');

        if (!detail.hasAttribute('open')) {
          content.style.height = '0px';
        }
        summary.addEventListener('click', (e) => this.handleDetailClick(e, detail, content));
        detail.addEventListener('close-detail', () => this.animateClose(detail, content));
      });
    }

    handleDetailClick(e, detail, content) {
      e.preventDefault();

      if (detail.hasAttribute('open')) {
        this.animateClose(detail, content);
      } else {
        this.animateOpen(detail, content);
      }
    }

    animateOpen(detail, content) {
      // Close other open details
      this.closeOtherDetails(detail);

      // Open animation
      detail.setAttribute('open', '');
      const height = content.scrollHeight;
      content.style.height = '0px';
      // Force reflow
      content.offsetHeight;
      content.style.height = `${height}px`;

      // Remove fixed height after animation
      content.addEventListener(
        'transitionend',
        () => {
          content.style.height = 'auto';
        },
        { once: true },
      );
    }

    animateClose(detail, content) {
      content.style.height = `${content.scrollHeight}px`;
      // Force reflow
      content.offsetHeight;
      content.style.height = '0px';

      content.addEventListener(
        'transitionend',
        () => {
          detail.removeAttribute('open');
        },
        { once: true },
      );
    }

    closeOtherDetails(currentDetail) {
      this.details.forEach((detail) => {
        if (detail !== currentDetail && detail.hasAttribute('open')) {
          detail.dispatchEvent(new CustomEvent('close-detail'));
        }
      });
    }

    removeEventListeners() {
      this.details.forEach((detail) => {
        const summary = detail.querySelector('summary');
        const content = detail.querySelector('.accordion__container');
        content.style.removeProperty('height');
        summary.removeEventListener('click', this.handleDetailClick);
        detail.removeEventListener('close-detail', this.closeOtherDetails);
      });
    }
  }
  customElements.define('collapsible-group', CollapsibleGroup);
}
